interface HeroBadgeProps {
  text: string;
}

export default function HeroBadge({ text }: HeroBadgeProps) {
  return (
    <div className="service-hero-badge">
      <span className="service-hero-badge-dot" />
      {text}
    </div>
  );
}
